import { trpc } from '@web/lib/trpc';

import { DoctorDetailsCard } from './doctors-details-card';
import { toast } from 'sonner';
import { DoctorData } from '@shared/types';

type EditDoctorDialogProps = {
  onClose?: () => void;
};

export function CreateDoctorDialog({ onClose }: EditDoctorDialogProps) {
  const { mutateAsync: createDoctorMutation } =
    trpc.doctor.create.useMutation();

  const { data: brands } = trpc.brand.listAll.useQuery();

  if (!brands) return null;

  const doctor: DoctorData = {
    id: '',
    fullName: '',
    displayName: '',
    specialty: '',
    brand: brands[0],
    status: 'active',
    email: '',
    phone: '',
    webpage: '',
  };

  return (
    <DoctorDetailsCard
      newEntityCreation={true}
      defaultEditMode
      brandsList={brands}
      doctor={doctor}
      onSubmit={async (data) => {
        console.log('-->   ~ onSubmit={ ~ data:', data);
        const result = await createDoctorMutation(data)
          .then(() => 'SUCCESS' as const)
          .catch(() => {
            return 'FAILED' as const;
          });

        if (result === 'SUCCESS') {
          toast('Doctor successfully created', {
            description: `you can now get in touch with ${data.fullName} !`,
          });

          onClose?.();
          return;
        }

        // if failed
        {
          toast.error('Failed to create Doctor', {
            description: 'Please try again.',
          });
        }

        throw new Error('Failed to create Doctor');
      }}
      onClose={() => {
        onClose?.();
      }}
    />
  );
}
